import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// components
import FormSubCompany from "./FormSubCompany";
import ModalBox from "../../ui/ModalBox";
import { Typography } from "@mui/material";

const AddCompany = () => {
  const navigate = useNavigate();
  const [subCompanyName, setSubCompanyName] = useState('x');
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <div>
      <Typography variant="Poster" component="h3" gutterBottom>
        Add Sub Company
      </Typography>
      <div>
        <FormSubCompany
          handleSuccess={handleSuccess}
          setSubCompanyName={setSubCompanyName}
        />
      </div>
      <ModalBox
        open={open}
        handleClose={handleClose}
        operation="add"
        text="The add operation has been completed successfully.. You added new sub company "
        name={subCompanyName}
      />
    </div>
  );
};

export default React.memo(AddCompany);
